import { Suspense, useContext } from "react";
import { Outlet, Navigate, useRoutes } from "react-router-dom";

// Import all component dependencies
import AddNewChannel from "../components/TVSchedule/AddNewChannel";
import ChannelList from "../Pages/TV/ChannelList";
import NewMessage from "../components/Message/NewMessage";
import MessageHistory from "../components/Message/MessageHistory";
import User from "../components/hr/User";
import DeputUser from "../components/hr/DeputyUser";
import VerificationCenter from "../Pages/Users/verification-center.page";
import PublicReport from "../Pages/Public Reports/public-report.page";
import PublicReportDetailsPage from "../Pages/Public Reports/public-report-details.page";
import DeputyReport from "../Pages/Deputy Reports/Other Venus Reports/other-venue-report.page";
import TVProgramReport from "../components/Report/TVProgramReport";
import AddNewCity from "../components/city/AddNewCity";
import CityList from "../components/city/CityList";
import MallList from "../components/mall/MallList";
import NotFound from "../components/notfound/NotFound";
import Login from "../Pages/Auth/Login";
import UpdatePassword from "../Pages/Auth/UpdatePassword";
import Layout2 from "../layouts/layout2/main";
import Home from "../components/Home/Home"; // Assuming this exists for the home route
import UserContext from "../context/UserContext";
import { MovieTest } from "../Pages/Movies/movie.page";
import { Dashboard } from "@mui/icons-material";
import { MyDashboard } from "../Pages/MainDashboard/my-dashboard";
import DeleteAppAccount from "../components/App/DeleteAccount";
import AccountRemoveSuccessful from "../components/App/AccountRemoved";
import PrivacyPolicy from "../components/App/PrivacyPolicy";
import TVProgramList from "../components/TVSchedule/TvProgramList";
import AddTvProgram from "../components/TVSchedule/TvProgramAdd";
import TVProgramSchedule from "../components/TVSchedule/TVProgramSchedule";
import DeputyReviews from "../Pages/Deputy Reports/Movie Report/movie-report.page";
import DeputyReviewDetails from "../Pages/Deputy Reports/Movie Report/movie-report-details.page";
import DeputyRegisterRequest from "../components/hr/DeputyRegisterRequest";
import AddTVProgramSchedule from "../components/TVSchedule/AddTVProgramSchedule";
import BoardMembers from "../components/Appointees/Board Members/board-members";
import BoardMemberDetails from "../components/Appointees/Board Members/board-member-details";
import DeputyReportTV from "../Pages/Deputy Reports/TV Report/tv-report.page";
import { DeputyDashboard } from "../components/Deputies/deputy-dashboard";
import Officials from "../components/Appointees/Officials/officials";
import OfficialDetails from "../components/Appointees/Officials/officials-details";
import Committees from "../components/Appointees/Committees/committee";
import CommitteeMembers from "../components/Appointees/Committees/committee-members";
import MTRCBUsers from "../components/hr/MTRCBUsers";
import AdminUsers from "../components/hr/AdminUsers";
import RatingsList from "../components/Ratings/RatingsList";
import NewsPage from "../Pages/Updates/News/news";
import EventsPage from "../Pages/Updates/Events/events";
import AddNewsPage from "../Pages/Updates/News/add-news";
import { PostersPage } from "../Pages/Movies/posters.page";
import AddEventPage from "../Pages/Updates/Events/add-events";
import TVReportDetailsPage from "../Pages/Deputy Reports/TV Report/tv-report-details.page";
import TVReportsPage from "../Pages/Deputy Reports/TV Report/tv-report.page";
import OtherVenueReportDetailsPage from "../Pages/Deputy Reports/Other Venus Reports/deputy-report-detail";
import DeputyReportSummaryPage from "../Pages/Deputy Reports/Summary/report-summary.page";
import TheatresPage from "../Pages/Movie House/Theatres/theatres.page";
import TheatreDetailsPage from "../Pages/Movie House/Theatres/theatre-details.page";
import EditNewsPage from "../Pages/Updates/News/edit-news";
import EditEventPage from "../Pages/Updates/Events/edit-events";
import AppIssueReportsPage from "../Pages/AppIssueReports/AppIssueReports.page";
import ClaimedTicketRequestsPage from "../Pages/TicketRequests/ticket-requests.page";
import MallsPage from "../components/mall/MallList";
import MallsDetailsPage from "../components/mall/MallsDetailsPage";
import NoReportDeputiesPage from "../Pages/Deputy Reports/NoReports/deputy-no-reports.page";
import AppPageForm from "../Pages/AppPages/AppPageForm";
import SoftwareUpdatesPage from "../Pages/SoftwareUpdates/software-updates.page";
import PressReleases from "../components/PressReleases/press-releases";
import MTRCBMoviesPage from "../Pages/MTRCB Monitoring/Movies/movies.page";
import MTRCBMovieDetailsPage from "../Pages/MTRCB Monitoring/Movies/movie-details.page";

export default function Router() {
  const user = useContext(UserContext);
  const isAllowed = user?.user !== null || localStorage.getItem("access_token");

  const ProtectedRoute = ({ children }: any) =>
    isAllowed ? children : <Navigate to="/login" replace />;

  return useRoutes([
    {
      path: "/",
      element: (
        <Layout2>
          <Suspense fallback={<div>Loading...</div>}>
            <Outlet />
          </Suspense>
        </Layout2>
      ),

      children: [
        {
          index: true,
          element: (
            <ProtectedRoute>
              <MyDashboard />
            </ProtectedRoute>
          ),
        },
        { path: "dashboard", element: <MyDashboard /> },

        {
          path: "movies",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "movies", element: <MovieTest /> },
            { path: "movies/posters", element: <PostersPage /> },
          ],
        },

        {
          path: "tv",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "add-channel", element: <AddNewChannel /> },
            { path: "channels", element: <ChannelList /> },

            { path: "program", element: <TVProgramList /> },
            { path: "program-add", element: <AddTvProgram /> },
            { path: "tv-channel-schedules", element: <TVProgramSchedule /> },
            { path: "add-tv-program-schedule", element: <AddTVProgramSchedule /> },
          ],
        },
        { path: "public-reports", element: <PublicReport /> },
        { path: "public-reports/details", element: <PublicReportDetailsPage /> },
        { path: "public-reports/:id", element: <PublicReportDetailsPage /> },

        {
          path: "hr",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "deputy-register-request", element: <DeputyRegisterRequest /> },
            { path: "deputy-user", element: <DeputUser /> },
            { path: "user", element: <User /> },
            { path: "verify", element: <VerificationCenter /> },
            { path: "mtrcb-users", element: <MTRCBUsers /> },
            { path: "admin-users", element: <AdminUsers /> },
          ],
        },
        {
          path: "messages",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "new-message", element: <NewMessage /> },
            { path: "message-history", element: <MessageHistory /> },
          ],
        },
        {
          path: "movie-house",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [

            { path: "malls", element: <MallList /> },
            { path: "malls/new", element: <MallsDetailsPage /> },
            { path: "malls/:id", element: <MallsDetailsPage /> },
            { path: "theaters/:id", element: <TheatreDetailsPage /> },
            { path: "theaters", element: <TheatresPage /> },
          ],
        },
        {
          path: "deputies",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "reviews", element: <DeputyReviews /> },
            { path: "details", element: <DeputyReviewDetails /> },
            { path: "", element: <DeputyReviews /> },
          ],
        },
        {
          path: "deputies",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "dashboard", element: <DeputyDashboard /> },
            { path: "summary", element: <DeputyReportSummaryPage /> },
            { path: "no-reports", element: <NoReportDeputiesPage /> },
            { path: "reviews", element: <DeputyReviews /> },
            { path: "details", element: <DeputyReviewDetails /> },
            { path: "tv-reports", element: <TVReportsPage /> },
            { path: "tv-reports/:id", element: <TVReportDetailsPage /> },
            { path: "other-reports", element: <DeputyReport /> },
            { path: "other-reports/:id", element: <OtherVenueReportDetailsPage /> },

          ],
        },
        {
          path: "mtrcb-monitoring",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "movies", element: <MTRCBMoviesPage /> },
            { path: "details", element: <MTRCBMovieDetailsPage /> },
          ],
        },
        { path: "tickets", element: <ClaimedTicketRequestsPage /> },
        {
          path: "board-committees",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "list", element: <DeputyReviews /> },
            { path: "details", element: <DeputyReviewDetails /> },
          ],
        },
        {
          path: "app-contents",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "officials", element: <Officials /> },
            { path: "official-details", element: <OfficialDetails /> },
            { path: "board-members", element: <BoardMembers /> },
            { path: "board-member-details", element: <BoardMemberDetails /> },
            { path: "others", element: <DeputyReviewDetails /> },
            { path: "committees", element: <Committees /> },
            { path: "committee-members", element: <CommitteeMembers /> },
            { path: "ratings/list", element: <RatingsList /> },
            { path: "press-releases", element: <PressReleases /> },
            { path: "who-is-board", element: <AppPageForm /> },
          ],
        },

        {
          path: "newsupdates",
          element: (
            <ProtectedRoute>
              <Outlet />
            </ProtectedRoute>
          ),
          children: [
            { path: "news", element: <NewsPage /> },
            { path: "news/add", element: <AddNewsPage /> },
            { path: "news/edit/:id", element: <EditNewsPage /> },
            { path: "events", element: <EventsPage /> },
            { path: "events/add", element: <AddEventPage /> },
            { path: "events/edit/:id", element: <EditEventPage /> },
          ],
        },
        { path: "appissues", element: <AppIssueReportsPage /> },
        { path: "software-updates", element: <SoftwareUpdatesPage /> },
      ],
    },
    { path: "login", element: <Login /> },
    { path: "*", element: <NotFound /> },



    //MOBILE APP
    { path: "mobile-app/delete", element: <DeleteAppAccount /> },
    { path: "mobile-app/delete/success", element: <AccountRemoveSuccessful /> },
    { path: "mobile-app/privacy-policy", element: <PrivacyPolicy /> },
    { path: "mobile-app/update-password", element: <UpdatePassword /> },

    // PASSWORD RESET
    { path: "updatePassword", element: <UpdatePassword /> },
    { path: "reset-password", element: <UpdatePassword /> },
  ]);
}
